import { render, staticRenderFns } from "./input-switcher.vue?vue&type=template&id=75e8d618&scoped=true&"
import script from "./input-switcher.vue?vue&type=script&lang=js&"
export * from "./input-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e8d618",
  null
  
)

export default component.exports